import React, { useState, useEffect } from "react";
import zafClient from '../zafclient';
import { getMarketplaceHeaders } from '../constants/zendesk';

export const TicketContext = React.createContext();

const TICKET_DEVICE_ID_TAG_PREFIX = "blitzz_deviceid";

const TicketContextProvider = (props) => {
  const [tickeInfo, setTicketInfo] = useState({
    phone: "",
    email: "",
    id: "",
    UserId: "",
    ticketTags: [],
    ticketDeviceIdList: [],
  });
  useEffect(() => {
    setTicketInfo(tickeInfo);
  }, [tickeInfo]);

  // Fetch Ticket data from Zendesk
  const getTicketData = () => {
    //Get current ticket info
    zafClient.get("ticket").then(function (ticketdata) {
      // Ticket tags — filtered subset that starts with "blitzz_deviceid" is
      // used by Cobrowse VisitorList to match incoming socket devices to
      // the current ticket.
      const ticketTags = Array.isArray(ticketdata?.ticket?.tags)
        ? ticketdata.ticket.tags
        : [];
      const ticketDeviceIdList = ticketTags.filter((t) =>
        typeof t === "string" && t.startsWith(TICKET_DEVICE_ID_TAG_PREFIX)
      );

      //Request user information
      //Set settings with required marketplace headers
      var settings = {
        url: "/api/v2/users/" + ticketdata.ticket.requester.id + ".json",
        type: "GET",
        dataType: "json",
        headers: getMarketplaceHeaders()
      };
      //Process request
      zafClient.request(settings).then(
        function (data) {
          var email = "";
          var phone = "";
          if (data.user.email) {
            console.error(data.user.email);

            email = data.user.email;
          }
          //fill input with phone number
          if (data.user.phone) {
            console.error(data.user.phone);

            phone = data.user.phone;
          }
          setTicketInfo({
            phone: phone,
            email: email,
            id: ticketdata.ticket.id,
            UserId: ticketdata.ticket.requester.id,
            ticketTags,
            ticketDeviceIdList,
          });
          console.error(tickeInfo);
        },
        function (response) {
          //Get error message
          var errorMessage =
            "Error: " + response.status + " - " + response.statusText;
          //Display error
          zafClient.invoke("notify", errorMessage, "error");
        }
      );
    });
  };

  useEffect(
    getTicketData, // <- function that will run on every dependency update
    [] // <-- empty dependency array
  );

  return (
    <TicketContext.Provider value={tickeInfo}>
      {props.children}
    </TicketContext.Provider>
  );
};

export default TicketContextProvider;
